import React from 'react';

const About: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-6 rounded">
        <p className="text-yellow-800 text-center font-medium">Currently employed</p>
      </div>
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">About Me</h1>
        <p className="text-xl text-gray-600">Welcome to my personal website!</p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center">
        {/* Profile Image Placeholder */}
        <div className="flex justify-center">
          <img 
            src={require('../images/profile.png')} 
            alt="Profile" 
            className="w-64 h-64 rounded-full object-cover border-4 border-white shadow-lg"
          />
        </div>

        {/* About Content */}
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-gray-900">Nicholas Iverson</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
          Hi, I’m Nicholas Iverson. I’m a Computer Science Master’s graduate with experience in backend software engineering and applied AI/ML. My graduate coursework focused on machine learning and large language models, with additional coursework in cybersecurity and data science.

          I recently completed graduate research in Responsible AI, where I worked on the design and evaluation of human-centered LLM systems for real-world, high-stakes applications, with an emphasis on safe human-AI interaction.

          Since January 2026, I’ve been working as a Software Engineer at KPMG, where I’m excited to work on building scalable, production systems. Long-term, I’m interested in roles that sit at the intersection of software engineering and AI, focused on deploying machine learning systems responsibly.
          </p>
          
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-900">Skills</h3>
            <div className="flex flex-wrap gap-2">
              {['Responsible AI', 'LLMs', 'Neural Networks', 'Machine Learning', 'Python', 'Java', 'C#', 'C/C++', 'scikit-learn', 'NumPy', 'SQL', 'PostgreSQL', 'JavaScript', 'TypeScript', 'Linux', 'Git', 'FastAPI', 'Docker', 'RESTful APIs', 'CI/CD', 'JUnit', 'Mockito'].map((skill) => (
                <span
                  key={skill}
                  className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-900">Interests</h3>
            <p className="text-gray-700">
            Outside of academic and professional pursuits, I am a travel enthusiast, and I also enjoy time outdoors, particularly skiing, hiking, and golf.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 
